import { Observable } from 'rxjs';
import { ApiCaller } from './api-caller.service';

export abstract class ApiConnector<TFull extends { _id: TId }, TSummary, TId> {
  constructor(
    protected apiCaller: ApiCaller,
    protected apiPrefix: string,
    protected slug: string,
  ) {}

  get(itemId?: TId): Observable<TFull> {
    if (itemId) {
      return this.apiCaller.getRequest<TFull>(this.apiPrefix, `${this.slug}/${itemId}`);
    }
    return this.apiCaller.getRequest<TFull>(this.apiPrefix, `${this.slug}`);
  }

  getByIds(uuids: TId[]): Observable<TSummary[]> {
    return this.apiCaller.getRequest<TSummary[]>(this.apiPrefix, `${this.slug}?uuids=${uuids.join(',')}`);
  }

  create<TCreation>(newItem: TCreation): Observable<TFull> {
    return this.apiCaller.postRequest<TFull>(this.apiPrefix, this.slug, newItem);
  }

  update(updateObject: TFull): Observable<TFull> {
    return this.apiCaller.putRequest<TFull>(this.apiPrefix, `${this.slug}/${updateObject._id}`, updateObject);
  }

  delete(itemId: TId): Observable<boolean> {
    return this.apiCaller.deleteRequest(this.apiPrefix, `${this.slug}/${itemId}`);
  }
}
